import { render, staticRenderFns } from "./CameraDialog.vue?vue&type=template&id=4af001a9&scoped=true"
import script from "./CameraDialog.vue?vue&type=script&lang=js"
export * from "./CameraDialog.vue?vue&type=script&lang=js"
import style0 from "./CameraDialog.vue?vue&type=style&index=0&id=4af001a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af001a9",
  null
  
)

export default component.exports